import * as React from 'react';
import { useContext } from 'react';
import { PromoModal as PromoModalComponent } from '@cian/frontend-newbuilding-promo-modal-widget';
import { usePreparedOfferPromo } from './hooks';
import { usePromoDetailsConfig } from '../../hooks/promoDetails';
import { PromoOfferCardContext } from '../../utils/promoOfferCardContext';
import { trackCallButtonClick } from '../CallButton/tracking';
import { PromoOfferDetailsControls } from '../PromoOfferDetailsControls';
import { trackBlockClick } from '../PromoOffersSelection/tracking';

interface IPromoModalProps {
  onPromoModalClose(): void;
}

export const PromoModal = ({ onPromoModalClose }: IPromoModalProps) => {
  const { promoInfo, offerUrl, gaLabel, offerId } = useContext(PromoOfferCardContext);

  const preparedPromo = usePreparedOfferPromo();
  const promoModalConfig = usePromoDetailsConfig();

  const onCallClick = React.useCallback(
    () =>
      trackCallButtonClick({
        customUrl: gaLabel,
        id: offerId,
        action: 'Open_detail_promo',
        extra: { promoId: promoInfo.uniquePromoId, is_price_with_discount: promoInfo.promoType === 'discount' },
      }),
    [gaLabel, offerId, promoInfo],
  );

  const onOfferLinkClick = React.useCallback(
    () =>
      trackBlockClick({
        offersIds: [offerId],
        clickType: 'to_offers',
      }),
    [offerId],
  );

  /* istanbul ignore next */
  if (!preparedPromo) {
    return null;
  }

  return (
    <PromoModalComponent
      open={true}
      onOpenChange={onPromoModalClose}
      promo={preparedPromo}
      controls={
        <PromoOfferDetailsControls
          offerUrl={offerUrl}
          actionText={promoInfo.actionText}
          onCallButtonClick={onCallClick}
          onOfferLinkClick={onOfferLinkClick}
        />
      }
      config={promoModalConfig}
    />
  );
};
